import { useState, useEffect } from "react";

export const Nav = ({ t }) => {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const link = (id, label, testId) => (
    <a
      key={id}
      href={`#${id}`}
      data-testid={testId}
      className="text-sm text-[#A8A294] hover:text-[#F4F0E6] transition-colors hidden md:inline"
    >
      {label}
    </a>
  );

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 backdrop-blur-xl transition-colors ${
        scrolled ? "bg-[#0D0B0A]/80 border-b border-[#F4F0E6]/10" : "bg-[#0D0B0A]/30"
      }`}
    >
      <nav className="max-w-6xl mx-auto px-6 h-16 flex items-center justify-between">
        <a href="#hero" data-testid="nav-logo" className="flex items-center gap-3">
          <img src="/brand/mark.png" alt="Legend mark" className="h-8 w-auto" />
          <img src="/brand/wordmark.png" alt="Legend" className="h-5 w-auto" />
        </a>
        <div className="flex items-center gap-6">
          {link("event", t.nav.event, "nav-link-event")}
          {link("location", t.nav.location, "nav-link-location")}
          {link("vision", t.nav.vision, "nav-link-vision")}
          {link("participate", t.nav.participate, "nav-link-participate")}
          <a
            href="#join"
            data-testid="nav-cta-waitlist"
            className="text-xs sm:text-sm bg-[#D4A373] text-[#0D0B0A] rounded-full px-4 py-2 font-medium hover:bg-[#B87B41] transition-colors"
          >
            {t.nav.join}
          </a>
        </div>
      </nav>
    </header>
  );
};
